import React from 'react';

/**
 * Global page-level skeleton shown during React.lazy() chunk loading.
 * Uses the global .kp-skel shimmer class defined in index.css.
 * Renders a generic page placeholder (header + tabs + cards + content area).
 */
export default function PageLoadingSkeleton() {
  return (
    <div style={{ padding: '28px 32px', maxWidth: 1320, margin: '0 auto' }}>
      {/* Page header placeholder */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 }}>
        <div
          className="kp-skel"
          style={{ width: 48, height: 48, borderRadius: 12, flexShrink: 0 }}
        />
        <div style={{ flex: 1 }}>
          <div
            className="kp-skel"
            style={{ width: '30%', height: 20, marginBottom: 10, borderRadius: 6 }}
          />
          <div
            className="kp-skel"
            style={{ width: '45%', height: 14, borderRadius: 6 }}
          />
        </div>
      </div>

      {/* Tabs bar placeholder */}
      <div
        className="kp-skel"
        style={{ height: 44, borderRadius: 12, marginBottom: 20 }}
      />

      {/* KPI / content cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 12,
          marginBottom: 20,
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="kp-skel"
            style={{ height: 96, borderRadius: 12 }}
          />
        ))}
      </div>

      {/* Table / main content area */}
      <div
        className="kp-skel"
        style={{ height: 240, borderRadius: 12 }}
      />
    </div>
  );
}
